<template>
  <section id="navigation-dashboard-view">
    <div class="navigation-container">
      <el-row
        type="flex"
        :gutter="30"
        justify="center"
        class="dashboard-view-block"
      >
        <el-col :span="5">
          <div class="configure-links">
            <ul>
              <li v-if="hasPermission('cases', 'view')">
                <div class="each-menu-item" @click="goToAllCases">
                  <img
                    src="@/assets/images/icons/dashboard/icon_1.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                  <p>All Cases</p>
                </div>
              </li>
              <li v-if="hasPermission('send_outs', 'view')">
                <router-link to="/all-send-outs" class="each-menu-item">
                  <img
                    src="@/assets/images/icons/dashboard/icon_2.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                  <p>SendOuts</p>
                </router-link>
              </li>
              <li v-if="hasPermission('orders', 'view')">
                <div @click="goToAllOrders" class="each-menu-item">
                  <img
                    src="@/assets/images/icons/dashboard/icon_3.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                  <p>Orders</p>
                </div>
              </li>
            </ul>
            <div class="shapes">
              <img
                src="../assets/images/icons/dashboardLeftIcon.svg"
                alt="icon"
                class="img-fluid iconOne"
              />
              <img
                src="../assets/images/icons/dashboardRightIcon.svg"
                alt="icon"
                class="img-fluid iconTwo"
              />
            </div>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="navigation-links">
            <div class="headingPart">
              <h3>Navigation</h3>
            </div>
            <div class="bodyPart dashboardGridPart">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="12" :lg="8">
                  <div class="eachGroup">
                    <h4>Cases</h4>
                    <ul>
                      <li
                        :class="
                          hasActiveClass([
                            'AllCases',
                            'cases',
                            'Case-Information-Update',
                            'CaseInfo',
                            'CaseView',
                            'TestNotes',
                            'TestReports',
                            'TestResults',
                            'PendingCases',
                          ])
                        "
                      >
                        <router-link
                          :to="{
                            name: 'AllCases',
                          }"
                        >
                          All Cases
                        </router-link>
                      </li>
                      <li
                        :class="hasActiveClass(['ActiveCases'])"
                      >
                        <router-link
                          :to="{
                            name: 'ActiveCases',
                          }"
                        >
                          Active Cases</router-link
                        >
                      </li>
                      <li
                        :class="hasActiveClass(['CompleteCases'])"
                      >
                        <router-link
                          :to="{
                            name: 'CompleteCases',
                          }"
                        >
                          Finalized Cases</router-link
                        >
                      </li>
                    </ul>
                    <div class="groupIcon">
                      <img
                        src="../assets/images/icons/menu/cases.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div class="eachGroup">
                    <h4>Orders</h4>
                    <ul>
                      <li
                        v-if="hasPermission('orders', 'view')"
                        :class="
                          hasActiveClass([
                            'NewOrder',
                            'AllOrders',
                            'ActiveOrders',
                            'CompleteOrders',
                            'Order-Information',
                          ])
                        "
                      >
                        <router-link to="/all-orders"
                          >Orders</router-link
                        >
                      </li>
                    </ul>
                    <div class="groupIcon">
                      <img
                        src="../assets/images/icons/menu/all-orders.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div class="eachGroup" >
                    <h4>Medical Group Rules</h4>
                    <ul>
                      <li>
                        <router-link to="/all-insurances"
                          >Insurances</router-link
                        >
                      </li>
                      <li v-if="isBillingUser">
                        <router-link to="/commercial-insurance-settings"
                          >Settings</router-link
                        >
                      </li>
                      <li v-if="isBillingUser">
                        <router-link
                          to="/commercial-insurance-facility-settings"
                          >Facility Settings</router-link
                        >
                      </li>
                      <li v-if="canViewPotentialPayers">
                        <router-link to="/potential-payers"
                          >Potential Payers</router-link
                        >
                      </li>
                      <!-- <li :class="hasActiveClass(['AllCodingRules', 'AllClaim', 'AllARRules', 'PaymentRules', 'PatientRules', 'AddRules', 'UpdatedRules'])">
                        <router-link to="/billing-rules/coding-rules"
                          >Billing Rule Book</router-link
                        >
                      </li> -->
                    </ul>
                    <div class="groupIcon">
                      <img
                        src="../assets/images/icons/menu/all-orders.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8">
                  <div
                    class="eachGroup"
                    v-if="hasPermission('case_reports', 'view')"
                  >
                    <h4>Reports</h4>
                    <ul>
                      <li
                        v-if="hasPermission('cases', 'save')"
                        :class="hasActiveClass(['Exports'])"
                      >
                        <router-link to="/all-report-download">
                          Exports</router-link
                        >
                      </li>
                      <li
                        v-if="hasPermission('send_outs', 'view')"
                        :class="
                          hasActiveClass([
                            'allSendOuts',
                            'ActiveSendOuts',
                            'CompleteSendOuts',
                            'SendOutsView',
                            'SendoutsInformation',
                          ])
                        "
                      >
                        <router-link to="/all-send-outs"> SendOuts</router-link>
                      </li>
                    </ul>
                    <div class="groupIcon">
                      <img
                        src="../assets/images/icons/menu/reports.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div
                    class="eachGroup"
                    v-if="hasPermission('physicians', 'view_new')"
                  >
                    <h4>My Lab</h4>
                    <ul>
                      <li
                        v-if="hasPermission('user_accounts', 'add')"
                        :class="
                          hasActiveClass([
                            'userAccounts',
                            'ActiveUserAccounts',
                            'InActiveUserAccounts',
                            'addUser',
                            'EditUserAccount',
                          ])
                        "
                      >
                        <router-link to="/user-accounts">
                          User Accounts</router-link
                        >
                      </li>
                    </ul>
                    <div class="groupIcon">
                      <img
                        src="../assets/images/icons/menu/lab-config.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div
                    class="eachGroup"
                    v-if="hasPermission('physicians', 'view_new')"
                  >
                    <h4>CLIENTS</h4>
                    <ul>
                      <li
                        v-if="hasPermission('hospitals', 'view')"
                        :class="
                          hasActiveClass([
                            'AllHospitals',
                          ])
                        "
                      >
                        <router-link to="/ordering-facilities">
                          Ordering Facilities</router-link
                        >
                      </li>
                      <li
                        v-if="hasPermission('physicians', 'view')"
                        :class="
                          hasActiveClass([
                            'AllPhysicians',
                            'ActivePhysicians',
                            'InActivePhysicians',
                          ])
                        "
                      >
                        <router-link to="/physicians"> Physicians</router-link>
                      </li>
                    </ul>
                    <div class="groupIcon">
                      <img
                        src="../assets/images/icons/menu/lab-config.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div
                    class="eachGroup"
                  >
                    <h4>VALIDATIONS</h4>
                    <ul>
                      <li
                        :class="hasActiveClass(['ValidationCases'])"
                        v-if="hasPermission('validations', 'cases')"
                      >
                        <router-link to="/validation-cases"
                          >Validation Cases</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8">
                  <div
                    class="eachGroup"
                    v-if="hasPermission('ICD_code', 'view')"
                  >
                    <h4>OTHERS</h4>
                    <ul>
                      <li
                      v-if="hasPermission('ICD_code', 'view')"
                        :class="hasActiveClass(['icd10codes'])"
                      >
                        <router-link to="/icd-10-codes">
                          ICD-10 codes</router-link
                        >
                      </li>
                      <li :class="hasActiveClass(['AllCodingRules', 'AllClaim', 'AllARRules', 'PaymentRules', 'PatientRules', 'AddRules', 'UpdatedRules'])">
                        <router-link to="/billing-rules/coding-rules"
                          >Billing Rule Book</router-link
                        >
                      </li>
                      <!-- <li
                        v-if="hasPermission('user_logs', 'view')"
                        :class="hasActiveClass(['casesLogs'])"
                      >
                        <router-link to="/logs/cases">User Logs</router-link>
                      </li>
                      <li
                        v-if="hasPermission('email_logs', 'view')"
                        :class="hasActiveClass(['EmailLogs'])"
                      >
                        <router-link to="/email-logs">Email Logs</router-link>
                      </li> -->
                      <!-- <li
                        v-if="hasPermission('logs', 'view')"
                        :class="hasActiveClass(['UrinalysisPendingCases'])"
                      >
                        <router-link to="/urinalysis-pending-cases">
                          Urinalysis Pending Cases</router-link
                        >
                      </li>
                       <li
                        v-if="hasPermission('cases', 'labdaq_view')"
                        :class="
                          hasActiveClass([
                            'LabdaqPendingOrders',
                            'LabdaqPendingResults',
                            'LabdaqInvalidOrders',
                            'LabdaqCompletedOrders',
                          ])
                        "
                      >
                        <router-link to="/lab-daq/pending-orders">
                          <span> LABDAQ Configuration </span></router-link
                        >
                      </li> -->
                      <!-- <li v-if="hasPermission('qc_charts', 'upload')">
                        <router-link to="/ua-qc-results"
                          >UA QC Results</router-link
                        >
                      </li>
                      <li v-if="hasPermission('add_tests', 'view')">
                        <router-link to="/clinical-chemistry-tests"
                          >Clinical Chemistry Config</router-link
                        >
                      </li>
                      <li v-if="!isBillingUser || isSuperAdmin">
                        <router-link to="/all-insurances"
                          >Insurances</router-link
                        >
                      </li> -->
                    
                      <!-- <li v-if="hasPermission('emr_insurances', 'view')">
                        <router-link to="/emr-insurances"
                          >EMR Insurances</router-link
                        >
                      </li>
                      <li v-if="hasPermission('publish_notifications', 'view')">
                        <router-link to="/publish-notifications"
                          >Publish Notifications</router-link
                        >
                      </li>
                      <li v-if="isAbletoAddInsurance">
                        <router-link to="/billing-automation-rules"
                          >Billing Automation Rules</router-link
                        >
                      </li> -->
                    </ul>
                    <div class="groupIcon">
                      <img
                        src="../assets/images/icons/menu/others.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div
                    class="eachGroup"
                    v-if="hasPermission('global_permissions', 'edit')"
                  >
                    <h4>VALIDATIONS</h4>
                    <ul>
                      <li
                        :class="hasActiveClass(['ValidationCases'])"
                        v-if="hasPermission('validations', 'cases')"
                      >
                        <router-link to="/validation-cases"
                          >Validation Cases</router-link
                        >
                      </li>
                      <!-- <li
                        v-if="hasPermission('validations', 'orders')"
                        :class="hasActiveClass(['ValidationOrders'])"
                      >
                        <router-link to="/validation-orders"
                          >Validation TestGo Orders</router-link
                        >
                      </li> -->
                    </ul>
                    <div class="groupIcon">
                      <img
                        src="../assets/images/icons/menu/validations.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  created() {},
  mixins: [UserPermissionsHelper],
  mounted() {},
  unmounted() {},
  data() {
    return {
    };
  },
  computed: {
    hasActiveClass() {
      return (routeName) => {
        if (routeName.indexOf(this.$route.name) != -1) {
          return "default-page-active";
        }
        return "";
      };
    },
  },
  methods: {
    goToAllCases() {
        this.$router.push({
          path: "/all-cases",
        });
    },
    goToAllOrders() {
      this.$router.push({
        path: "/all-orders",
      });
    },
  },
};
</script>

<style lang="scss">
#navigation-dashboard-view {
  height: calc(100vh - 70px);
  background: #f0f3f8;
  overflow: auto;
  padding: 1rem 0;
  .navigation-container {
    max-width: 80%;
    margin: 0 auto;
  }
  @mixin each-links {
    background-color: #ffffff;
    border-radius: 5px;
    margin: 7px;
    text-align: center;
    background-color: #fff;
    border-radius: 5px;
    &:hover {
      background-color: rgba($color: #fff, $alpha: 0.6);
    }
    .text {
      padding: 1rem;
      color: #215fad;
      font-weight: 500;
      text-align: start;
    }
    .icon {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.5em 1em 1.5em;
      .all-cases-text {
        text-align: start;
      }
      span {
        padding: 10px 10px;
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .dashboard-view-block {
    $fixedHeight: 85vh;
    .configure-links {
      position: relative;
      width: 100%;
      background: #1b2459;
      border-radius: 20px;
      height: $fixedHeight;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .iconOne {
        position: absolute;
        left: 0;
        top: 40px;
        width: 30px;
      }
      .iconTwo {
        position: absolute;
        right: 0;
        bottom: 40px;
        width: 30px;
      }
      ul {
        text-align: center;
        display: flex;
        flex-direction: column;
        height: 70%;
        align-items: flex-start;
        justify-content: space-between;
        li {
          .each-menu-item {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px 0;
            a {
              display: flex;
              align-items: center;
              padding: 5px 0;
            }
            img {
              width: 24px;
              height: 24px;
              margin-right: 10px;
            }
            p {
              color: #ffffff;
              transition: all 0.2s ease-in-out;
            }
          }
          &:hover {
            cursor: pointer;
            p {
              color: #bf1b39;
            }
          }
        }
      }
    }
    .navigation-links {
      border-radius: 5px;
      background: #ffffff;
      border: 0.8px solid #d9d6ff;
      border-radius: 20px;
      height: $fixedHeight;
      .headingPart {
        padding: 20px 40px;
        border-bottom: 0.8px dashed #d9d6ff;
        @media (min-width: 1200px) and (max-width: 1450px) {
          padding: 10px 40px;
        }
        h3 {
          font-size: 1.1em;
          color: #1a55af;
          text-transform: uppercase;
        }
      }
      .bodyPart {
        padding: 20px 40px 20px 20px;
        @media (min-width: 1200px) and (max-width: 1450px) {
          padding: 10px 40px 5px;
        }
        .eachGroup {
          margin-bottom: 20px;
          padding-bottom: 20px;
          position: relative;
          padding-left: 20px;
          padding-right: 20px;

          @media (min-width: 1200px) and (max-width: 1450px) {
            margin-bottom: 10px;
            padding-bottom: 10px;
          }
          &:not(:last-child) {
            border-bottom: 0.8px dashed #d9d6ff;
          }
          .groupIcon {
            position: absolute;
            top: 3px;
            right: 20px;
          }
          h4 {
            color: #1a55af;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 1em;
            margin-bottom: 7px;
          }
          ul {
            margin-left: -10px;
            li {
              &:not(:last-child) {
                margin-bottom: 7px;
              }
              a {
                font-size: 0.85em;
                color: #262626;
                transition: all 0.2s ease-in-out;
                display: inline-block;
                padding: 2px 10px;
                border-radius: 30px;
                &:hover {
                  color: #bf1b39;
                  transform: translateX(2px);
                }
                &.router-link-exact-active {
                  background: #bf1b39;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
